
/* injects from baggage-loader */

import { queryBuilder } from '@lbs/swarm-client';

export const getSwarmSubscriptionRequestSecondPopularSports = (sectionType) => {
    const builder = queryBuilder()
        .useSource('betting')
        .selectSport(['id', 'name', 'alias', 'order'])
        .selectGame('@count')
        .whereSport('type').in([0, 2, 5]);

    if (sectionType === 'live') {
        builder.whereGame('type').is(1)
    } else {
        builder
            .orWhereGame('type').in([0, 2])
            .orWhereGame('visible_in_prematch').is(1);
    }

    return builder.getParams();
};

export const getSwarmSubscriptionRequestPopularSports = () => {
    const builder = queryBuilder()
        .useSource('betting')
        .selectSport(["id", "name", "alias", "order"])
        .selectGame('@count')
        .whereSport('type').in([0, 2, 5]);

    return builder.getParams();
}